import { CommonModule } from "@angular/common";
import { Component, OnInit, OnDestroy } from "@angular/core";
import { Router } from "@angular/router";
import { Subject } from "rxjs";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  standalone: true,
  imports: [CommonModule],
})
export class LoginComponent implements OnInit, OnDestroy {
  private readonly _destroying$ = new Subject<void>();

  constructor(private router: Router) {}
  ngOnInit() {
    setTimeout(() => {
      this.goToPrevious();
    }, 200);
  }

  goToPrevious() {
    if (
      localStorage.getItem("previousUrl") &&
      localStorage.getItem("previousUrl") != "/" &&
      localStorage.getItem("previousUrl") != "/login" &&
      localStorage.getItem("previousUrl") != "/access_token"
    ) {
      setTimeout(() => {
        this.router.navigate([localStorage.getItem("previousUrl")]);

        return;
      }, 100);
    } else {
      setTimeout(() => {
        this.router.navigate(["/home"]);
      }, 100);
    }
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }
}
